import {EntityManagePage} from "base/entity";
import {useConfigModule} from "base/provider";

export const ManagePage = () => {
    const {moduleFilter} = useConfigModule();

    return <EntityManagePage filter={moduleFilter}></EntityManagePage>;
};
